import { EstatePlanningFields } from 'src/non-financial-data/v2/sections/fields/EstatePlanningFields';
import IndividualEntityForm from '../IndividualEntityForm';

export default function EstatePlanningV2() {
  return (
    <IndividualEntityForm title="Estate planning">
      <EstatePlanningFields />
    </IndividualEntityForm>
  );
}
